import { WorkspacePanelButton } from '../panels/workspace-panel-button';
import { COMPACT_CLI_HEIGHT, STANDARD_CLI_HEIGHT } from './use-open-command-line-panel';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';

export const CommandLineButton = function CommandLineButton(): React.ReactElement {
    const { commandLineCompactByDefault } = useEnabledFeatures();
    return (
        <WorkspacePanelButton
            tooltipText="Command Line"
            workspacePanelType="COMMAND_LINE"
            aria-label="open command line"
            icon="CommandLine"
            shouldFocus
            onAddPanel={(baseArgs) => {
                return {
                    ...baseArgs,
                    height: commandLineCompactByDefault ? COMPACT_CLI_HEIGHT : STANDARD_CLI_HEIGHT,
                };
            }}
        />
    );
};
